(function () {
  'use strict';

  function normalize(value) {
    return (value || '').toLowerCase().replace(/\s+/g, ' ').trim();
  }

  function initHelpSearch(root) {
    var input = root.querySelector('[data-sm-care-search]');
    if (!input) return;

    var items = Array.prototype.slice.call(root.querySelectorAll('[data-sm-care-search-item]'));
    var status = root.querySelector('[data-sm-care-search-status]');

    function filterItems() {
      var query = normalize(input.value);
      var visible = 0;

      items.forEach(function (item) {
        var terms = normalize(item.getAttribute('data-search-terms'));
        var matches = !query || (terms + ' ' + normalize(item.textContent)).indexOf(query) !== -1;
        item.hidden = !matches;
        if (matches) visible += 1;
      });

      if (status) {
        status.textContent = query
          ? visible + (visible === 1 ? ' result found' : ' results found')
          : '';
      }
    }

    input.addEventListener('input', filterItems);
  }

  function initFaqSearch(root) {
    var input = root.querySelector('[data-sm-care-faq-search]');
    if (!input) return;

    var items = Array.prototype.slice.call(root.querySelectorAll('[data-sm-care-faq-item]'));
    var sections = Array.prototype.slice.call(root.querySelectorAll('[data-sm-care-faq-section]'));
    var empty = root.querySelector('[data-sm-care-faq-empty]');
    var status = root.querySelector('[data-sm-care-faq-status]');

    function filterFaqs() {
      var query = normalize(input.value);
      var visible = 0;

      items.forEach(function (item) {
        var matches = !query || normalize(item.textContent).indexOf(query) !== -1;
        item.hidden = !matches;

        if (matches) {
          visible += 1;
          if (query.length >= 2) item.open = true;
        } else {
          item.open = false;
        }
      });

      sections.forEach(function (section) {
        section.hidden = !section.querySelector('[data-sm-care-faq-item]:not([hidden])');
      });

      if (empty) empty.hidden = visible !== 0;
      if (status) {
        status.textContent = query
          ? visible + (visible === 1 ? ' answer found' : ' answers found')
          : '';
      }
    }

    input.addEventListener('input', filterFaqs);
  }

  var trackerPromise;

  function loadTrackerScript() {
    if (window.YQV5 && typeof window.YQV5.trackSingle === 'function') {
      return Promise.resolve(window.YQV5);
    }

    if (trackerPromise) return trackerPromise;

    trackerPromise = new Promise(function (resolve, reject) {
      var existing = document.querySelector('script[data-sm-17track]');
      var script = existing || document.createElement('script');
      var timeout;

      function finish() {
        window.clearTimeout(timeout);
        if (window.YQV5 && typeof window.YQV5.trackSingle === 'function') {
          resolve(window.YQV5);
        } else {
          reject(new Error('17TRACK API unavailable'));
        }
      }

      function fail() {
        window.clearTimeout(timeout);
        reject(new Error('17TRACK script failed to load'));
      }

      if (!existing) {
        script.src = 'https://www.17track.net/externalcall.js';
        script.async = true;
        script.defer = true;
        script.setAttribute('data-sm-17track', '');
        script.addEventListener('load', finish, { once: true });
        script.addEventListener('error', fail, { once: true });
        document.head.appendChild(script);
      } else {
        script.addEventListener('load', finish, { once: true });
        script.addEventListener('error', fail, { once: true });
        window.setTimeout(finish, 0);
      }

      timeout = window.setTimeout(function () {
        reject(new Error('17TRACK script timed out'));
      }, 8000);
    }).catch(function (error) {
      trackerPromise = null;
      throw error;
    });

    return trackerPromise;
  }

  function initTracking(root) {
    var input = root.querySelector('#sm-track-number');
    var submit = root.querySelector('#sm-track-submit');
    var feedback = root.querySelector('#sm-track-feedback');
    var results = root.querySelector('#sm-track-results');
    var container = root.querySelector('#sm-track-container');
    var reset = root.querySelector('#sm-track-reset');
    var retry = root.querySelector('#sm-track-retry');
    var fallback = root.querySelector('#sm-track-fallback');
    var lastNumber = '';
    var frameTimer;

    if (!input || !submit || !feedback || !results || !container) return;

    function isMobile() {
      return window.matchMedia && window.matchMedia('(max-width: 720px)').matches;
    }

    function setLoading(loading) {
      submit.disabled = loading;
      submit.textContent = loading ? 'Tracking…' : 'Track order';
      container.setAttribute('aria-busy', loading ? 'true' : 'false');
    }

    function showFeedback(message, type) {
      feedback.textContent = message;
      feedback.className = 'sm-form-feedback is-visible ' + type;
    }

    function clearFeedback() {
      feedback.textContent = '';
      feedback.className = 'sm-form-feedback';
    }

    function showFallback(show) {
      if (fallback) fallback.hidden = !show;
      if (retry) retry.hidden = !show;
    }

    function normalizeTrackingNumber() {
      return (input.value || '').trim().replace(/\s+/g, '');
    }

    function validateTrackingNumber(number) {
      if (!number) {
        showFeedback('Please enter the tracking number from your shipping confirmation email.', 'is-error');
        input.focus();
        return false;
      }

      if (number.length < 5 || !/^[A-Za-z0-9-]+$/.test(number)) {
        showFeedback('Please check the tracking number and try again.', 'is-error');
        input.focus();
        return false;
      }

      return true;
    }

    function prepareFrame(frame) {
      frame.setAttribute('title', '17TRACK shipment results');
      frame.style.setProperty('display', 'block', 'important');
      frame.style.setProperty('width', '100%', 'important');
      frame.style.setProperty('max-width', '100%', 'important');
      frame.style.setProperty('min-width', '0', 'important');
      frame.style.setProperty('height', isMobile() ? '660px' : '590px', 'important');
      frame.style.setProperty('border', '0', 'important');
    }

    function waitForFrame() {
      var attempts = 0;
      window.clearInterval(frameTimer);

      frameTimer = window.setInterval(function () {
        attempts += 1;
        var frame = container.querySelector('iframe');

        if (frame) {
          window.clearInterval(frameTimer);
          prepareFrame(frame);
          setLoading(false);
          showFallback(false);
          showFeedback('Tracking results loaded below.', 'is-info');
          window.setTimeout(clearFeedback, 1800);
          window.setTimeout(function () {
            results.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }, 100);
          return;
        }

        if (attempts >= 32) {
          window.clearInterval(frameTimer);
          setLoading(false);
          showFallback(true);
          showFeedback('The embedded tracker did not load. Please retry or use the secure 17TRACK link.', 'is-error');
        }
      }, 250);
    }

    function renderTracker(api, number) {
      container.innerHTML = '';
      results.hidden = false;
      results.classList.add('is-visible');
      showFallback(false);
      setLoading(true);
      showFeedback('Loading secure carrier updates…', 'is-info');

      try {
        api.trackSingle({
          YQ_ContainerId: 'sm-track-container',
          YQ_Height: isMobile() ? 660 : 590,
          YQ_Fc: '0',
          YQ_Lang: 'en',
          YQ_Num: number
        });
        waitForFrame();
      } catch (error) {
        setLoading(false);
        showFallback(true);
        showFeedback('We could not load tracking results. Please retry or use the secure tracking link.', 'is-error');
      }
    }

    function startTracking() {
      var number = normalizeTrackingNumber();
      clearFeedback();
      showFallback(false);

      if (!validateTrackingNumber(number)) return;

      lastNumber = number;
      input.value = number;
      results.hidden = false;
      results.classList.add('is-visible');
      setLoading(true);
      showFeedback('Connecting securely to 17TRACK…', 'is-info');

      loadTrackerScript()
        .then(function (api) {
          renderTracker(api, number);
        })
        .catch(function () {
          setLoading(false);
          showFallback(true);
          showFeedback('The tracking service is taking longer than expected. Please retry or open 17TRACK securely.', 'is-error');
        });
    }

    submit.addEventListener('click', startTracking);

    input.addEventListener('keydown', function (event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        startTracking();
      }
    });

    if (retry) {
      retry.addEventListener('click', function () {
        if (lastNumber) input.value = lastNumber;
        startTracking();
      });
    }

    if (reset) {
      reset.addEventListener('click', function () {
        window.clearInterval(frameTimer);
        input.value = '';
        lastNumber = '';
        container.innerHTML = '';
        results.hidden = true;
        results.classList.remove('is-visible');
        showFallback(false);
        clearFeedback();
        setLoading(false);
        input.focus();
      });
    }

    window.addEventListener('resize', function () {
      var frame = container.querySelector('iframe');
      if (frame) prepareFrame(frame);
    });
  }

  function init() {
    document.querySelectorAll('[data-sm-care-root]').forEach(function (root) {
      initHelpSearch(root);
      initFaqSearch(root);
    });

    document.querySelectorAll('[data-sm-track-root]').forEach(initTracking);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
